export function pathToSlugs(path: string): string[] {
  const cleanPath = path.replace(/\?.+/, "");
  if (cleanPath === "/" || cleanPath === "") {
    return ["start"];
  }
  return cleanPath.split("/").filter((x) => !!x);
}
